import { Box, Heading, Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';
import Card from 'shared/components/horizon-ui/card/Card';
import InfiniteTable from 'shared/components/table/InfiniteTable';
import useGetColors from 'shared/hooks/useGetColors';
import { ModuleE, PathsE, PathsParams, SearchParams } from "shared/routes";
import { useGetColumns, useGetGetBreadcrumbs } from './constants';
import { useGetColumns as useGetColumnsActorSettings } from '../actor-settings/constants';
import { useParams } from 'react-router-dom';
import { useGetOneService, useGet3thPartyServices } from 'shared/api/requests/services';
import PageTitle from 'shared/views/admin/PageTitle';
import { ActorSettingsT, SettingsT } from 'shared/api/types/services';
import { TableNameE } from 'shared/api/types/common';
import { useAuthContext } from 'shared/contexts/AuthContext';
import useStateFromQueryParams from "../../../hooks/useStateFromQueryParams";

const Index = () => {
  const { serviceId } = useParams<PathsParams[PathsE.SETTINGS]>();
  const { self } = useAuthContext();

  const { page, size } = useStateFromQueryParams().getSearchParams<SearchParams[PathsE.UPDATE_SETTING]>();


  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });

  const { t } = useTranslation();
  const { blue800 } = useGetColors();

  const columns = useGetColumns({ serviceId, page, size });
  const columnsActorSettings = useGetColumnsActorSettings({ serviceId });
  const breadcrumbs = useGetGetBreadcrumbs();

  const { useGetSettings: useGetSettingsNoRole } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
    module: ModuleE.SETTINGS
  });
  const useGetSettings = useGetSettingsNoRole(self.role);

  const { useGetServiceModule: useGetServiceModuleActorSettings } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
    module: ModuleE.PROMPT_SETTINGS
  });

  if (!currentService) return null;

  return (
    <Box>
      <PageTitle title={t('services.settings')} breadcrumbs={breadcrumbs} />
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex alignItems="center">
          <Heading size="md" color={blue800}>
            {t('services.settingsTable')}
          </Heading>
        </Flex>
        <InfiniteTable<SettingsT>
          query={useGetSettings as FixMeLater}
          columns={columns}
          filterFields={[]}
          tableName={TableNameE.SETTINGS}
        />
      </Card>
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex alignItems="center" justifyContent="space-between">
          <Heading size="md" color={blue800}>
            {t('services.actorsSettings')}
          </Heading>

          {/* <Link
            layout={LayoutsE.DASHBOARD}
            path={PathsE.CREATE_ACTOR_SETTING}
            pathsParams={{
              serviceId,
            }}
          >
            <Button
              fontSize="16px"
              ml="20px"
              color="white"
              backgroundColor="brand.500"
              fontWeight="600"
              _hover={{
                backgroundColor: "brand.400"
              }}
              paddingY="8px"
              display="flex"
              borderRadius="8px"
              alignItems="center"
            >
              <MuiIcon name="add" size={24} color="gray800" variant="rounded" />
              <Text ml="8px">{t('services.actorsSetting')}</Text>
            </Button>
          </Link> */}
        </Flex>
        <InfiniteTable<ActorSettingsT>
          query={useGetServiceModuleActorSettings as FixMeLater}
          columns={columnsActorSettings}
          filterFields={[]}
          tableName={TableNameE.ACTOR_SETTINGS}
        />
      </Card>
    </Box>
  );
};

export default Index;